/**
 * Created by h.nanev on 6/15/2016.
 */
import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import documentedProps from "./documentation/ModalDocumentedProps";

import("./Modal.less");

export default class Modal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: props.visible
        };

        this.onClose = this.onClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentWillReceiveProps(props) {
        if (this.state.visible !== props.visible) {
            this.setState({
                visible: props.visible
            });
        }
    }

    onClose() {
        let stateToSet = {};
        stateToSet.visible = false;
        this.setState(stateToSet, () => {
            if (this.props.onClose) {
                this.props.onClose(this.state);
            }
        });
    }

    onSubmit() {
        let stateToSet = {};
        if (this.props.closeOnSubmit) {
            stateToSet.visible = false;
            this.setState(stateToSet, () => {
                if (this.props.onSubmit) {
                    this.props.onSubmit(this.state);
                }
            });
        } else {
            if (this.props.onSubmit) {
                this.props.onSubmit(this.state);
            }
        }
    }

    _filterChildren() {
        var header = null;
        var body = null;
        var footer = null;

        React.Children.forEach(
            this.props.children,
            (child) => {
                if (!React.isValidElement(child)) return;
                const displayName = child.type.displayName || child.type.name;
                if (displayName.includes("ModalHeader")) {
                    let headerProps = {
                        onClose: this.onClose,
                        hideCloseIcon: this.props.hideCloseIcon
                    };
                    header = React.cloneElement(child, headerProps);
                } else if (displayName.includes("ModalBody")) {
                    body = child;
                } else if (displayName.includes("ModalFooter")) {
                    let footerProps = { onModalClose: this.onClose, onModalSubmit: this.onSubmit };
                    footer = React.cloneElement(child, footerProps);
                }
            },
            this
        );

        return {
            header: header,
            body: body,
            footer: footer
        };
    }

    render() {
        let sizeClasses = {
            small: "tq-modal-s",
            medium: "tq-modal-m",
            large: "tq-modal-l"
        };
        let extraClasses = this.props.extraClasses || "";
        let classes = {
            mainContainer:
                extraClasses + (this.state.visible ? " tq-modal tq-modal-visible" : " tq-modal"),
            overlay: "tq-modal-overlay",
            modalContainer: this.props.size
                ? "tq-modal-container " + sizeClasses[this.props.size]
                : "tq-modal-container " + sizeClasses["medium"]
        };

        let children = this._filterChildren();
        //overrides predefined modal sizes, by allowing arbitrary width in percentage
        let containerStyle = this.props.containerWidth
            ? { width: this.props.containerWidth + "%" }
            : {};
        let modalInnerMarkup = (
            <div className={classes.modalContainer} style={containerStyle}>
                {children.header}
                {children.body}
                {children.footer}
            </div>
        );

        if (this.props.skipModalMarkup) {
            modalInnerMarkup = [children.header, children.body, children.footer];
        }

        let modal = (
            <div className={classes.mainContainer} data-tq-id={this.props.dataTqId}>
                <div className={classes.overlay} />
                {modalInnerMarkup}
            </div>
        );
        if (this.props.bodyPortal) {
            return ReactDOM.createPortal(modal, document.body);
        } else {
            return modal;
        }
    }
}

Modal.displayName = "Modal";

Modal.propTypes = {
    extraClasses: PropTypes.string,
    visible: PropTypes.bool,
    size: PropTypes.oneOf(["small", "medium", "large"]),
    closeOnSubmit: PropTypes.bool,
    skipModalMarkup: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    dataTqId: PropTypes.string,
    bodyPortal: PropTypes.bool,
    containerWidth: PropTypes.number,
    disablePageScroll: PropTypes.bool,
    hideCloseIcon: PropTypes.bool
};

Modal.documentedProps = documentedProps;
